import { loader } from 'graphql.macro'

export default function siteTypes ({ dataLoaders, queryKey }) {
  const [, haulerId, filterByIds = null] = queryKey
  const schema = loader('./siteTypes.graphql')
  return dataLoaders.dispatcher.graphQLClient.request(schema, { haulerId, filterByIds })
}
